import { getString } from "../../common/common";

export const PNR_NUM = "Enter_PNR_Number";
export const MOB_NUM = "Enter_Mobile_Number";
export const MOB_NUM_ERR = "Enter_valid_mobile_no";
export const ENTER_OTP = "ENTER_OTP";
export const VERIFY = "VERIFY";
export const RESEND_OTP_IN = "RESEND_OTP_IN";
export const RESEND_OTP_NOW = "RESEND_OTP_NOW";
export const ENTER_VALID_OTP = "ENTER_VALID_OTP";

export const translations = {
  en: {
    [PNR_NUM]: "Enter PNR Number",
    [MOB_NUM]: "Enter Mobile Number",
    [MOB_NUM_ERR]: "Enter valid mobile no",
    [ENTER_OTP]: "Enter OTP (One Time Password) ",
    [VERIFY]: "Verify",
    [RESEND_OTP_IN]: "Resend Otp in ",
    [RESEND_OTP_NOW]: "Resend the OTP now",
    [ENTER_VALID_OTP]: "Please enter Valid otp",
  },
  kn: {
    [PNR_NUM]: "PNR ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [MOB_NUM]: "ಮೊಬೈಲ್ ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [MOB_NUM_ERR]: "ಸರಿಯಾದ ಮೊಬೈಲ್ ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [ENTER_OTP]: "OTP (ಒನ್ ಟೈಮ್ ಗುಪ್ತಪದ) ಎಂಟರ್ ಮಾಡಿ",
    [VERIFY]: "ಪರಿಶೀಲಿಸಿ",
    [RESEND_OTP_IN]: "OTP ಅನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಿ",
    [RESEND_OTP_NOW]: "ಈಗ OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
    [ENTER_VALID_OTP]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ OTPಯನ್ನು ಎಂಟರ್ ಮಾಡಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
